import { getData, postData, putData, deleteData } from '../plugins/ApiCalls'

export function fetchUrlBuilderLinks(formId) {
  return getData('forms/' + formId + '/url-builder-links')
}

export function createUrlBuilderLink(formId, link) {
  return postData('forms/' + formId + '/url-builder-links', link)
}

export function updateUrlBuilderLink(linkId, link) {
  return putData('url-builder-links/' + linkId, link)
}

export function duplicateUrlBuilderLink(linkId) {
  return postData('url-builder-links/' + linkId + '/duplicate', {})
}

export function deleteUrlBuilderLink(linkId) {
  return deleteData('url-builder-links/' + linkId)
}

export function bulkDeleteUrlBuilderLinks(formId, ids) {
  return postData('forms/' + formId + '/url-builder-links/bulk-delete', { ids })
}
